__turbopack_context__.v({
  "shrink": "TB32cG_shrink",
});
